import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import InputTextField from '../../../components/form/InputTextField';
import { useForm } from 'react-hook-form';
import HTTP from '../../../config/axios';
import { fieldRequired } from '../../../config/validations/rules';
import SimpleSpinner from '../../../components/common/Spinner';
import SimpleToast from '../../../components/common/Toast';
import MultiRadio from '../../../components/form/MultiRadio';
import { encryptLocalStorage } from '../../../config/utils/storage';


const BookingConfig: React.FC = () => {
    const { handleSubmit, formState: { errors }, setError, clearErrors, control, reset, watch } = useForm<Record<string, any>>();
    const [isLoading, setIsLoading] = useState(false);
    const [toast, setToast] = useState({ open: false, header: '', message: '', variant: '' })
    const [configStatus,setConfigStatus] = useState()
    const configValueStatus = watch("bookingConfig");
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);


    const bookingOptions = [
         { label: 'Amount', value: '0' },
        { label: 'Percentage', value: '1' }
       
    ]

    useEffect(() => {
        const user = encryptLocalStorage.getItem('userInfo');
        setIsSuperAdmin(user?.roleWeight >= 90);
    }, []);

    useEffect(()=>{
        //Fetch the vehicle AMount
        const getBookingAmount = async () => {
            try {
                const response = await HTTP.get(`/api/booking/booking-amount`);
                const { data: { status, data, msg, error } } = response
                if (status == 1) {
                   
                    reset({ 'bookingAmount': data.value, 'bookingConfig': data.status })
               
                }
            } catch (error: any) {
                if (error.response?.status === 401) {
                    setToast({ open: true, header: 'Access Denied', message: 'You do not have permission to access this resource', variant: 'danger' })
                } else {
                    setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
                }
            }
        }

        getBookingAmount()
    },[])

    useEffect(() => {
        setConfigStatus(configValueStatus);
    }, [configValueStatus]);

    const onSubmit = async (submitData: any) => {
        if (!isSuperAdmin) {
            setToast({ open: true, header: 'Access Denied', message: 'You do not have permission to perform this action', variant: 'danger' })
            return;
        }
        try {
            setIsLoading(true);
            const response = await HTTP.post(`/api/admin/booking/addEditBookingAmount`, submitData)
            setToast({ open: true, header: response.data.status?'Success':'failed', 
                message: response.data.status?response.data.message:'Something went wrong', variant: response.data.status?'success': 'danger'})
            
        }
        catch (error: any) {
            if (error.response?.status === 401) {
                setToast({ open: true, header: 'Access Denied', message: 'You do not have permission to perform this action', variant: 'danger' })
            } else {
                setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
            }
        }
        finally {
            setIsLoading(false);    
        }
    }


    return (
        <>
            <div id="wrapper">
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div className="container-fluid">
                            <Row className='mb-1'>
                                <div className="d-flex">
                                    <div className="p-2 flex-grow-1"><h2 className="mb-0 text-gray">Booking Configuration</h2></div>
                                </div>
                            </Row>
                            <Form onSubmit={handleSubmit(onSubmit)} className='p-2'>
                                <div className="d-flex flex-row align-items-center">
                                    
                                        <Form.Label htmlFor={`childId-id`} className="text-dark fw-semibold fs-6 me-3 mb-0">
                                            Booking Amount : <span className="text-danger fw-bold">*</span>
                                        </Form.Label>
                                    
                                        
                                        <InputTextField name="bookingAmount" label=""
                                        placeholder={(configStatus == 1) ? "Enter Percentage" : "Enter Amount"} clearErrors={clearErrors} classList='w-25'
                                            control={control} rule={{ required: fieldRequired }} type='number' disabled={!isSuperAdmin}/>
                                        
                                        <Button 
                                            variant={isSuperAdmin ? "primary" : "secondary"} 
                                            type="submit" 
                                            className='ms-3 py-2 px-4'
                                            disabled={!isSuperAdmin}
                                            title={isSuperAdmin ? "Save" : "Access denied"}
                                        >
                                            Save
                                        </Button>
                                </div>
                                <div className="p-2 mt-2 d-flex " style={{ cursor: isSuperAdmin ? "pointer" : "not-allowed" }}>
                                    <MultiRadio name="bookingConfig" control={control}
                                        options={bookingOptions} classList="mb-3 pt-0 px-2" selectedValue={watch("bookingConfig")}  />
                                </div>

                            </Form>
                            
                        </div>
                    </div>
                </div>
            </div>
            <SimpleSpinner show={isLoading} />
            <SimpleToast show={toast.open} header={toast.header}
                message={toast.message} variant={toast.variant}
                onClose={() => setToast({ ...toast, open: false })} />
        </>
    );
};

export default BookingConfig;